module.exports = __webpack_public_path__ + "img/1555167380.3268fde9.jpg";